import {withStyles} from 'material-ui/styles';
import {builderStyles} from '../../style/builder';
import PageSection from './section_base';


const card = withStyles(builderStyles)(PageSection);

export default card;



// WEBPACK FOOTER //
// ./src/containers/builder/sections/tab_edit/section_search_results.js